export default function InfoItem({title, type}: {title: string, type: string}) {
  return (
    <div className="flex gap-2 items-center">
      <div className="">{title}:</div>
      <div className="text-sm text-muted-foreground font-medium">{type}</div>
    </div>
  )
}